import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'

export const isCadastralDataComplete = (cadastralData: Record<string, any>) =>
  !!(
    cadastralData?.cadastral_sheet_number &&
    cadastralData?.cadastral_parcel_number &&
    cadastralData?.cadastral_subunit_number
  )

const useCadastralValidation = () => {
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)
  const { addErrorToContract, removeContractError } = useFormStatus()
  const { id } = useRetrieveActiveContractIdAndType()

  const validateCadastralData = (address: Record<string, any>, providerConfig: Record<string, any>) => {
    if (country !== 'it') return
    if (providerConfig?.cadastralFieldsMandatory && !isCadastralDataComplete(address.cadastralData ?? {})) {
      addErrorToContract(id, { cadastral_data: t('subscriptionForm:address_module.cadastral_fields.missing_data_error') })
      return
    }
    removeContractError(id, 'cadastral_data')
  }

  return { validateCadastralData }
}

export default useCadastralValidation
